import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Modal, Form, Input, Radio, Select, Icon, Switch, Badge, Tooltip } from 'antd';
import { permissionsTree } from '../Permissions/permissions-tree';
import { useAppContext } from '~/AppContext';

var FormItem = Form.Item;

var getAllKeys = function(items) {
  var keys = [];
  items.forEach(function(item) {
    if (item.key.indexOf('_PARENT') === -1 && item.key.indexOf('_SECTION') === -1) {
      keys.push(item.key);
    }
    if (item.children) {
      keys = keys.concat(getAllKeys(item.children));
    }
  });
  return keys;
};

var filterByPlan = function(items, isPremiumPlan, allowBetaFeatures) {
  return items.filter(function(item) {
    if (!isPremiumPlan && item.plans && item.plans.indexOf('starter') === -1) {
      return false;
    }
    if (!allowBetaFeatures && item.isBeta) {
      return false;
    }
    return true;
  }).map(function(item) {
    if (item.children) {
      return Object.assign({}, item, {
        children: filterByPlan(item.children, isPremiumPlan, allowBetaFeatures)
      });
    }
    return item;
  });
};

var getTopLevelModules = function(items, isPremiumPlan, allowBetaFeatures) {
  return filterByPlan(items, isPremiumPlan, allowBetaFeatures);
};

var UsersModalForm = function(props) {
  var visible = props.visible;
  var data = props.data;
  var form = props.form;
  var permissionsGroups = props.permissionsGroups;
  var onCancel = props.onCancel;
  var registerUser = props.registerUser;
  var savePermissions = props.savePermissions;
  var user = props.user;
  var getFieldDecorator = form.getFieldDecorator;

  var appCtx = useAppContext();
  var setOnboardingTaskAsDone = appCtx.setOnboardingTaskAsDone;

  var permissionsTypeState = useState('group');
  var permissionsType = permissionsTypeState[0];
  var setPermissionsType = permissionsTypeState[1];

  var savingState = useState(false);
  var isSaving = savingState[0];
  var setIsSaving = savingState[1];

  var checkedState = useState([]);
  var checkedKeys = checkedState[0];
  var setCheckedKeys = checkedState[1];

  var moduleState = useState(null);
  var selectedModule = moduleState[0];
  var setSelectedModule = moduleState[1];

  var expandedState = useState({});
  var expandedSections = expandedState[0];
  var setExpandedSections = expandedState[1];

  useEffect(function() {
    if (data) {
      setPermissionsType(data.permissions_group_id ? 'group' : 'custom');
      setCheckedKeys(data.permissions || []);
    } else {
      setCheckedKeys([]);
    }
    setSelectedModule(null);
    setExpandedSections({});
  }, [visible, data]);

  var isPremiumPlan = user.tenant.plan === 'premium';
  var allowBetaFeatures = user.tenant.is_beta_tester;
  var modules = getTopLevelModules(permissionsTree, isPremiumPlan, allowBetaFeatures);

  var isChecked = function(key) {
    return checkedKeys.indexOf(key) > -1;
  };

  var togglePermission = function(key) {
    var current = checkedKeys.slice();
    var index = current.indexOf(key);
    if (index > -1) {
      current.splice(index, 1);
    } else {
      current.push(key);
    }
    setCheckedKeys(current);
  };

  var toggleAllInModule = function(module, checked) {
    var items = module.children || [module];
    var allModuleKeys = getAllKeys(items);
    var current = checkedKeys.slice();

    if (checked) {
      allModuleKeys.forEach(function(key) {
        if (current.indexOf(key) === -1) {
          current.push(key);
        }
      });
    } else {
      current = current.filter(function(key) {
        return allModuleKeys.indexOf(key) === -1;
      });
    }
    setCheckedKeys(current);
  };

  var getModuleStats = function(module) {
    var items = module.children || [module];
    var allModuleKeys = getAllKeys(items);
    var checkedCount = allModuleKeys.filter(function(key) {
      return checkedKeys.indexOf(key) > -1;
    }).length;
    return { checked: checkedCount, total: allModuleKeys.length };
  };

  var isModuleFullyChecked = function(module) {
    var stats = getModuleStats(module);
    return stats.total > 0 && stats.checked === stats.total;
  };

  var toggleSection = function(key) {
    var updated = Object.assign({}, expandedSections);
    updated[key] = !updated[key];
    setExpandedSections(updated);
  };

  var totalStats = { checked: 0, total: 0 };
  modules.forEach(function(module) {
    var stats = getModuleStats(module);
    totalStats.checked += stats.checked;
    totalStats.total += stats.total;
  });

  var renderPermissionsList = function(items, level) {
    level = level || 0;
    var elements = [];

    items.forEach(function(item, idx) {
      var isLeaf = !item.children;
      var isParent = item.key.indexOf('_PARENT') > -1;

      // Section sublabel
      if (item.sectionLabel) {
        elements.push(
          React.createElement('div', {
            key: 'label-' + item.key,
            style: {
              fontSize: 11, fontWeight: 600, color: '#8c8c8c', textTransform: 'uppercase',
              letterSpacing: '0.5px', padding: '12px 0 6px', marginLeft: level * 16,
              marginTop: idx > 0 ? 8 : 0
            }
          }, item.sectionLabel)
        );
      }

      if (isLeaf && !isParent) {
        elements.push(
          React.createElement('div', {
            key: item.key,
            style: {
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '10px 12px', marginLeft: level * 16,
              background: isChecked(item.key) ? '#f6ffed' : '#fff',
              borderRadius: 6, marginBottom: 6,
              border: '1px solid ' + (isChecked(item.key) ? '#b7eb8f' : '#f0f0f0'),
              transition: 'all 0.2s'
            }
          },
            React.createElement('span', { style: { fontWeight: 400, display: 'flex', alignItems: 'center', gap: 6 } },
              item.title,
              item.info && React.createElement(Tooltip, { title: item.info, placement: 'top' },
                React.createElement(Icon, { type: 'info-circle', style: { fontSize: 13, color: '#bfbfbf', cursor: 'help' } })
              )
            ),
            React.createElement(Switch, {
              size: 'small', checked: isChecked(item.key),
              onChange: function() { togglePermission(item.key); }
            })
          )
        );
      } else if (item.children && item.children.length > 0) {
        var stats = getModuleStats(item);
        var isFullyChecked = stats.checked === stats.total && stats.total > 0;
        var isPartiallyChecked = stats.checked > 0 && stats.checked < stats.total;
        var isExpanded = expandedSections[item.key] || false;

        elements.push(
          React.createElement('div', { key: item.key, style: { marginBottom: 12, marginLeft: level * 16 } },
            React.createElement('div', {
              style: {
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                padding: '8px 12px', background: '#fafafa', borderRadius: 6,
                marginBottom: isExpanded ? 6 : 0, cursor: 'pointer'
              }
            },
              React.createElement('span', {
                style: { display: 'flex', alignItems: 'center', gap: 8, flex: 1 },
                onClick: function() { toggleSection(item.key); }
              },
                React.createElement(Icon, { type: isExpanded ? 'down' : 'right', style: { fontSize: 10, color: '#8c8c8c' } }),
                item.icon && React.createElement(Icon, { type: item.icon, style: { color: '#595959' } }),
                React.createElement('span', { style: { fontWeight: 500 } }, item.title),
                React.createElement(Badge, {
                  count: stats.checked + '/' + stats.total,
                  style: { backgroundColor: isFullyChecked ? '#52c41a' : isPartiallyChecked ? '#faad14' : '#d9d9d9', fontSize: 11 }
                })
              ),
              React.createElement('div', { style: { display: 'flex', alignItems: 'center', gap: 6 } },
                React.createElement('span', { style: { fontSize: 12, color: '#595959' } }, 'Todos'),
                React.createElement(Switch, {
                  size: 'small', checked: isFullyChecked,
                  onChange: function(checked) { toggleAllInModule(item, checked); }
                })
              )
            ),
            isExpanded && renderPermissionsList(item.children, level + 1)
          )
        );
      }
    });

    return elements;
  };

  var onSave = function() {
    var fieldsToValidate = permissionsType === 'custom' ? ['email'] : ['email', 'permissions_group_id'];

    form.validateFields(fieldsToValidate, function(err, values) {
      if (err) return;

      if (permissionsType === 'custom') {
        values.permissions = checkedKeys.filter(function(item) {
          return item.indexOf('_PARENT') === -1 && item.indexOf('_SECTION') === -1;
        });
        delete values.permissions_group_id;

        if (values.permissions.length === 0) {
          form.setFields({
            email: {
              value: values.email,
              errors: [new Error('Selecione pelo menos uma permissão!')]
            }
          });
          return;
        }
      } else {
        values.permissions_group_id = form.getFieldValue('permissions_group_id');
      }

      setIsSaving(true);

      var finish = function() { setIsSaving(false); };

      if (data) {
        var permissionsData = Object.assign({}, values);
        delete permissionsData.email;
        savePermissions(data.id, permissionsData).then(function() {
          form.resetFields();
          onCancel();
          setOnboardingTaskAsDone('b8c9d0');
        }).catch(function(e) { console.log(e); }).finally(finish);
      } else {
        registerUser(values).then(function() {
          form.resetFields();
          onCancel();
          setOnboardingTaskAsDone('b8c9d0');
        }).catch(function(e) { console.log(e); }).finally(finish);
      }
    });
  };

  var isPermissionsGroup = permissionsType === 'group';

  return (
    <Modal
      visible={visible}
      zIndex={1100}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Icon type={data ? 'edit' : 'user-add'} style={{ fontSize: 20, color: '#1890ff' }} />
          <span>{data ? 'Editar Permissões do Usuário' : 'Convidar novo usuário'}</span>
        </div>
      }
      okText={data ? 'Salvar' : 'Convidar'}
      onCancel={onCancel}
      onOk={onSave}
      okButtonProps={{ loading: isSaving, size: 'large' }}
      cancelButtonProps={{ size: 'large' }}
      destroyOnClose
      width={permissionsType === 'custom' ? 1000 : 520}
      bodyStyle={{ padding: 0 }}
    >
      {/* Email + Type */}
      <div style={{ padding: '20px 24px', borderBottom: '1px solid #f0f0f0' }}>
        <Form layout="vertical" style={{ marginBottom: 0 }}>
          <FormItem label="Email" style={{ marginBottom: 12 }}>
            {getFieldDecorator('email', {
              initialValue: data ? data.email : undefined,
              rules: [
                { required: true, message: 'Por favor informe o email!' },
                { type: 'email', message: 'Por favor, informe um e-mail válido!' },
              ],
            })(<Input disabled={!!data} size="large" prefix={<Icon type="mail" style={{ color: '#bfbfbf' }} />} />)}
          </FormItem>
          <FormItem label="Permissões" style={{ marginBottom: 0 }}>
            <Radio.Group
              value={permissionsType}
              buttonStyle="solid"
              size="small"
              onChange={function(e) { setPermissionsType(e.target.value); }}
            >
              <Radio.Button value="group">Grupos</Radio.Button>
              <Radio.Button value="custom">Customizado</Radio.Button>
            </Radio.Group>
            {isPermissionsGroup && (
              <div style={{ marginTop: 12 }}>
                {getFieldDecorator('permissions_group_id', {
                  initialValue: data ? data.permissions_group_id : undefined,
                  rules: [{ required: true, message: 'Selecione um grupo de permissões!' }],
                })(
                  <Select placeholder="Selecione um grupo de permissões" size="large" dropdownStyle={{ zIndex: 1101 }}>
                    {permissionsGroups.map(function(permission) {
                      return (
                        <Select.Option key={permission.id} value={permission.id}>
                          {permission.name}
                        </Select.Option>
                      );
                    })}
                  </Select>
                )}
              </div>
            )}
          </FormItem>
        </Form>
      </div>

      {/* Custom Permissions - Split View */}
      {!isPermissionsGroup && (
        <div style={{ display: 'flex', height: 500 }}>
          {/* Left Panel - Module List */}
          <div style={{
            width: 320,
            borderRight: '1px solid #f0f0f0',
            overflowY: 'auto',
            background: '#fafafa'
          }}>
            <div style={{ padding: '16px 16px 8px', borderBottom: '1px solid #f0f0f0', background: '#fff' }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: '#262626' }}>Módulos</div>
              <div style={{ fontSize: 12, color: '#8c8c8c' }}>
                {totalStats.checked} de {totalStats.total} permissões ativas
              </div>
            </div>

            {modules.map(function(module) {
              var stats = getModuleStats(module);
              var isEnabled = stats.checked > 0;
              var isFullyChecked = stats.total > 0 && stats.checked === stats.total;
              var isSelected = selectedModule && selectedModule.key === module.key;

              return (
                <div
                  key={module.key}
                  onClick={function() { setSelectedModule(module); }}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '10px 16px',
                    cursor: 'pointer',
                    background: isSelected ? '#e6f7ff' : '#fff',
                    borderLeft: isSelected ? '3px solid #1890ff' : '3px solid transparent',
                    borderBottom: '1px solid #f5f5f5',
                    transition: 'all 0.2s'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 1, minWidth: 0 }}>
                    <div style={{
                      width: 32,
                      height: 32,
                      borderRadius: 6,
                      background: isFullyChecked ? '#f6ffed' : isEnabled ? '#e6f7ff' : '#f5f5f5',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      {isFullyChecked ? (
                        React.createElement(Icon, {
                          type: 'check-circle',
                          theme: 'filled',
                          style: { fontSize: 16, color: '#52c41a' }
                        })
                      ) : (
                        React.createElement(Icon, {
                          type: module.icon || 'appstore',
                          style: { fontSize: 16, color: isEnabled ? '#1890ff' : '#bfbfbf' }
                        })
                      )}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{
                        fontWeight: 500,
                        fontSize: 13,
                        color: '#262626',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}>
                        {module.title}
                        {module.isBeta && (
                          React.createElement(Badge, { count: 'BETA', style: { marginLeft: 6, backgroundColor: '#722ed1', fontSize: 9 } })
                        )}
                      </div>
                      <div style={{ fontSize: 11, color: isFullyChecked ? '#52c41a' : '#8c8c8c' }}>
                        {isFullyChecked ? (
                          React.createElement('span', null,
                            React.createElement(Icon, { type: 'check', style: { fontSize: 10, marginRight: 4 } }),
                            'Acesso total'
                          )
                        ) : (
                          React.createElement('span', null, stats.checked + '/' + stats.total + ' permissões')
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Right Panel - Module Details */}
          <div style={{ flex: 1, overflowY: 'auto', background: '#fff' }}>
            {selectedModule ? (
              <div>
                <div style={{
                  padding: '20px 24px',
                  borderBottom: '1px solid #f0f0f0',
                  background: '#fafafa'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                      <div style={{
                        width: 44,
                        height: 44,
                        borderRadius: 8,
                        background: '#e6f7ff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}>
                        <Icon type={selectedModule.icon || 'appstore'} style={{ fontSize: 22, color: '#1890ff' }} />
                      </div>
                      <div>
                        <div style={{ fontWeight: 600, fontSize: 16, color: '#262626' }}>
                          {selectedModule.title}
                        </div>
                        {selectedModule.description && (
                          <div style={{ fontSize: 13, color: '#8c8c8c', marginTop: 2 }}>
                            {selectedModule.description}
                          </div>
                        )}
                      </div>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <span style={{ fontSize: 13, color: '#595959' }}>Selecionar todos</span>
                      <Switch
                        checked={isModuleFullyChecked(selectedModule)}
                        onChange={function(checked) { toggleAllInModule(selectedModule, checked); }}
                      />
                    </div>
                  </div>
                </div>

                <div style={{ padding: '16px 24px' }}>
                  {selectedModule.children ? (
                    renderPermissionsList(selectedModule.children, 0)
                  ) : (
                    <div style={{
                      padding: '12px',
                      background: isChecked(selectedModule.key) ? '#f6ffed' : '#fafafa',
                      borderRadius: 8,
                      border: '1px solid ' + (isChecked(selectedModule.key) ? '#b7eb8f' : '#e8e8e8'),
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}>
                      <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        Acesso ao módulo
                        {selectedModule.info && (
                          <Tooltip title={selectedModule.info} placement="top">
                            <Icon type="info-circle" style={{ fontSize: 13, color: '#bfbfbf', cursor: 'help' }} />
                          </Tooltip>
                        )}
                      </span>
                      <Switch
                        checked={isChecked(selectedModule.key)}
                        onChange={function() { togglePermission(selectedModule.key); }}
                      />
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                color: '#bfbfbf'
              }}>
                <Icon type="select" style={{ fontSize: 48, marginBottom: 16 }} />
                <div style={{ fontSize: 14 }}>Selecione um módulo para configurar</div>
                <div style={{ fontSize: 12, marginTop: 4 }}>Clique em um módulo na lista à esquerda</div>
              </div>
            )}
          </div>
        </div>
      )}
    </Modal>
  );
};

var mapStateToProps = function(state) {
  return {
    permissionsGroups: state.permissions.list,
    user: state.user
  };
};

var mapDispatchProps = function(dispatch) {
  return {
    registerUser: function(data) {
      return dispatch({
        type: 'REGISTER_USER',
        payload: {
          request: {
            method: 'post',
            url: '/user',
            data: data,
          },
        },
      });
    },
    savePermissions: function(id, data) {
      return dispatch({
        type: 'SAVE_PERMISSIONS_USER',
        payload: {
          request: {
            method: 'patch',
            url: '/user/' + id + '/permissions',
            data: data,
          },
        },
        id: id,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchProps
)(Form.create()(UsersModalForm));
